import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  dateField: {
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(0, -24px) scale(1)',
    },
    width: '100%',
    '& .MuiFormLabel-root.Mui-focused': {
      color: theme.palette.common.black,
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: theme.shape.borderRadius * 2,

      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.custom.border,
      },
    },
    '& fieldset': {
      borderColor: theme.palette.custom.border,
    },
    '& :focus-within': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderWidth: '1px',
        borderColor: theme.palette.custom.border,
      },
      '& fieldset': {
        borderWidth: '1px',
        boxShadow: '0px 0px 8px ' + theme.palette.primary.main,
      },
    },
  },
}));
